module.exports = __webpack_public_path__ + "static/media/img-background-groc-pattern.b4410b01.png";